import { UtilityFunctions } from '../../../../classes/UtilityFunctions';
import { waitForMap } from '@angular/router/src/utils/collection';
import { DataRequestReply, DataSet, DataRequestError, WebSocketData } from '../../../../interfaces/DisplayInterfaces';
import { Component, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { BaseWidget } from '../../BaseWidget/BaseWidget.component';
import { WidgetConfiguration, DataConsumerConfiguration, NameValue, DataPolicy, GenericTableConfiguration } from '../../../../interfaces/WidgetInterfaces';
import { CacheConstants } from '../../../../services/DisplayStateService'
import { PlatformTableComponent } from '../../../platform-table/platform-table.component';
import { DisplayStateService } from '../../../../services/DisplayStateService';
import { AppStateService } from '../../../../services/AppStateService';
import { WebPlatformApiService } from '../../../../services/WebPlatformApiService';
import { ClientSettingsService } from '../../../../services/ClientSettingsService';

import { QueueingSubject } from 'queueing-subject';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';
import websocketConnect from 'rxjs-websockets';
import 'rxjs/add/operator/share';

@Component({
  selector: 'app-data-policy-testing',
  template: `<div class="card">
  <div class="card-header">
    Select an existing widget configuration to test it's data consumer configuration
    <select class="form-control" (change)="onSelectChange()" [(ngModel)]="selectedWidgetConfig">
        <option *ngFor="let wc of filteredWidgetConfiguration" [ngValue]="wc">
                Widget = {{wc.name}},  Data policy = {{wc.dataConsumerConfiguration.dataPolicy}}
        </option>
      </select>
  </div>


  <div class="card-header">
    Select a data policy and configure additional data consumer configuration settings, then click 'Execute Request'
  </div>
  <div class="card-block">
    <app-data-consumer-config-editor [DataConsumerConfig]="DataConsumerConfig"></app-data-consumer-config-editor>
  </div>
  <div class="form-inline" *ngIf="!showWebSocketInput && DataConsumerConfig?.httpMethod != 'post' && DataConsumerConfig?.httpMethod != 'put'">
    <button type="button" class="btn btn-primary m-3" (click)="ExecuteTest()">Execute Request</button>
  </div>
  <div *ngIf="showWebSocketInput" class="form-inline">
    <label class="sr-only" for="inputWSMsg">WebSocket Input Message</label>
    <input [(ngModel)]="webSocketInputMessage" type="text" class="form-control col-md-10 m-3" id="inputWSMsg" placeholder="Enter the WebSocket message to send here">
    <button type="button" class="btn btn-primary" (click)="SendWebSocketMessage()">Send</button>
  </div>
  <div *ngIf="(DataConsumerConfig?.httpMethod == 'post' || DataConsumerConfig?.httpMethod == 'put') && DataConsumerConfig.httpMethod !== undefined" class="form-inline">
    <label class="sr-only" for="inputHttpMsg">HTTP Message</label>
    <textarea rows="3" [(ngModel)]="httpInputMessage" type="text" class="form-control col-md-10 m-3" id="inputHttpMsg" placeholder="Enter the http message body to send here"></textarea>
    <button type="button" class="btn btn-primary" (click)="SendHttpMessage()">Send</button>
  </div>
  <div *ngFor="let ctxInp of showCtxInputs; let ix = index" class="mx-3 form-inline">
    <label for="inputCtx{{ix}}">{{ctxInp.name}}</label>
    <input [(ngModel)]="ctxInp.value" type="text" class="form-control col-md-10 m-3" id="inputCtx{{ix}}" placeholder="Enter the context value to test with here">
  </div>
  <div *ngIf="showCtxInputs.length" class="mx-3 form-inline">
    <button type="button" class="btn btn-primary" (click)="ExecuteTest()">Execute with context</button>
  </div>
  <div *ngIf="waiting" class="card-block">
    <i class="fa fa-spinner fa-spin"></i>Loading data...
  </div>
</div>
<div class="card">
  <div class="card-header">
    Resulting data
  </div>
  <div *ngIf="dataSet" class="card-block">
    <app-platform-table [Dataset]="dataSet" [Config]="tableConfig"></app-platform-table>
  </div>
  <div *ngIf="freeJsonData" class="card-block">
    <pre>{{ freeJsonData | json }}</pre>
  </div>
</div>`,
  styles: [``]
})
export class DataPolicyTestingComponent extends BaseWidget implements OnDestroy {

  @ViewChild(PlatformTableComponent)
  private platformTableComponent: PlatformTableComponent;

  tableConfig: GenericTableConfiguration = 
  {
    sortAndfilterLocally: true,
    showColumnDropdowns: false,
    showFilterSortRow: false
  }
  
  DataConsumerConfig: DataConsumerConfiguration = {
    dataPolicy: '',
    fixedParameters: [],
    sortColumns: [],
    contextParameters: [],
    filterConfiguration: [],
    overrideCacheRules: { period: CacheConstants.NEVER },
    dataGrouping: { aggregations: [], groupBy: [], serverSide: false }
  };

  dataSet: DataSet;
  freeJsonData: any;
  dataKey: string;
  waiting = false;
  dataPolicies: DataPolicy[];
  showWebSocketInput: boolean = false;
  showCtxInputs = [];
  webSocketObj: WebSocketData;
  webSocketInputMessage: string;
  wsMessagesSubscription: Subscription;
  httpInputMessage: string;

  filteredWidgetConfiguration: WidgetConfiguration[] = [];
  selectedWidgetConfig: WidgetConfiguration;

  constructor(
    protected element: ElementRef,
    protected clientSettingsService: ClientSettingsService,
    protected displayStateService: DisplayStateService,
    protected appStateService: AppStateService,
    protected webPlatformApiService: WebPlatformApiService) {
      super(element, clientSettingsService, displayStateService, appStateService, webPlatformApiService);
    }
  onSelectChange() {
    this.showWebSocketInput = false;
    this.showCtxInputs = [];
    if (this.selectedWidgetConfig) {
      const dcc = this.selectedWidgetConfig.dataConsumerConfiguration;
      UtilityFunctions.InitializeDataConsumerConfigForEdit(dcc);
      this.DataConsumerConfig = dcc;
    }
  }

  onInitialize() {

    this.webPlatformApiService.GetConfig<DataPolicy[]>('DataPolicyList').subscribe(DataPolicyList => {
      const ValidDataPolicies = DataPolicyList.map( dataPolicy => dataPolicy.name );
      this.dataPolicies = DataPolicyList;

      if (!this.displayStateService.appState.widgetConfigList || this.displayStateService.appState.widgetConfigList.length === 0) {
        this.webPlatformApiService.GetConfig<WidgetConfiguration[]>('WidgetConfigurationList').subscribe(WidgetConfigurationList => {
          this.filterWidgets(WidgetConfigurationList, ValidDataPolicies);
        });
      } else {
        this.filterWidgets(this.displayStateService.appState.widgetConfigList, ValidDataPolicies);
      }
    });
  }

  filterWidgets(WidgetConfigurationList: WidgetConfiguration[], dataPolicyNames: string[]) {
    this.filteredWidgetConfiguration = WidgetConfigurationList.filter( wc => {
      if (wc.dataConsumerConfiguration) {
        return dataPolicyNames.indexOf(wc.dataConsumerConfiguration.dataPolicy) > -1;
      } else {
        return false;
      }
    });
  }

  ExecuteTest() {
    this.dataSet = undefined;
    this.freeJsonData = undefined;

    const dataPolicy = this.dataPolicies.find(dp => dp.name === this.DataConsumerConfig.dataPolicy);
    this.showWebSocketInput = false;
    if (this.wsMessagesSubscription) { this.wsMessagesSubscription.unsubscribe(); }
    // default is to use the middle layer as all data policies were originally designed that way.
    if (dataPolicy.useMiddleLayer || typeof dataPolicy.useMiddleLayer === 'undefined') {
      this.showCtxInputs = [];
      this.waiting = true;
      this.DataConsumerConfig.directUri = null;
      let requestReply = this.displayStateService.RequestData('Data Policy Testing Component', this.DataConsumerConfig);
      this.dataKey = requestReply.RequestKey;
      if (requestReply.Available) {
        // Don't want a local cached version!
        this.displayStateService.appState.cachedDataReplies.remove(requestReply.RequestKey);
        requestReply = this.displayStateService.RequestData('Data Policy Testing Component', this.DataConsumerConfig);
      }
    } else { // these are policies that are bypassing the middle layer 
      let tmpDataConsumerConfig = JSON.parse(JSON.stringify(this.DataConsumerConfig));     
      tmpDataConsumerConfig.directUri = dataPolicy.sourceURL;
      tmpDataConsumerConfig.apiStoreAppKey = dataPolicy.apiStoreAppKey;
      tmpDataConsumerConfig.apiStoreSendMtAdfsOpenId = dataPolicy.apiStoreSendMtAdfsOpenId;
      tmpDataConsumerConfig.httpMethod = dataPolicy.httpMethod;
      if (this.showCtxInputs.length) {
        let ctxObj = {};
        this.showCtxInputs.forEach(ctx => {
          ctxObj[ctx.name] = ctx.value;
        });
        tmpDataConsumerConfig.directUri = this.displayStateService.UpdateUriWithContextVars(
          tmpDataConsumerConfig.directUri, ctxObj, tmpDataConsumerConfig.dataPolicy);
      }

      if (tmpDataConsumerConfig.directUri.indexOf('{') !== -1) {
        const uri = tmpDataConsumerConfig.directUri;
        let urlParts = uri.split(/({.*})/g);
        urlParts.forEach(up => {
          if (up.indexOf('{') !== -1) {
            this.showCtxInputs.push({name: up.replace(/([{}])/g,''), value: ''});
          }
        });
      } else {
      this.waiting = true;
        if (dataPolicy.isAWebSocket) {
          this.showWebSocketInput = true;
          this.waiting = false;
          this.webSocketObj = this.displayStateService.GetWebSocketDataObj(tmpDataConsumerConfig);
          this.freeJsonData = [];
          this.wsMessagesSubscription = this.webSocketObj.Messages.subscribe((msg: string) => {
            if (this.freeJsonData) { 
              try {
                const parsed = JSON.parse(msg);
                this.freeJsonData.push(parsed);
              } catch (error) {
                  console.log('msg received, error parsing JSON', msg);
              }
            }
          });
        } else {
          this.displayStateService.RequestData('Data Policy Testing Component', tmpDataConsumerConfig);
        }
      }
    }
  }

  SendHttpMessage() {
    this.dataSet = undefined;
    this.freeJsonData = undefined;
    this.waiting = true;

    const dataPolicy = this.dataPolicies.find(dp => dp.name === this.DataConsumerConfig.dataPolicy);
    this.showWebSocketInput = false;
    if (this.wsMessagesSubscription) { this.wsMessagesSubscription.unsubscribe(); }
    // default is to use the middle layer as all data policies were originally designed that way.
    if (dataPolicy.useMiddleLayer === false) {
      this.DataConsumerConfig.directUri = dataPolicy.sourceURL;
      this.DataConsumerConfig.apiStoreAppKey = dataPolicy.apiStoreAppKey;
      this.DataConsumerConfig.apiStoreSendMtAdfsOpenId = dataPolicy.apiStoreSendMtAdfsOpenId;
      this.DataConsumerConfig.httpMethod = dataPolicy.httpMethod;
      let json = this.httpInputMessage;
      try {
        json = JSON.parse(this.httpInputMessage);
      } catch(e) {
        console.log('not valid json, sending as string');
      }
      this.displayStateService.SendData('Data Policy Testing Component', this.DataConsumerConfig, json);
    }
  }

  onDataAvailable(reply: DataRequestReply) {
    this.freeJsonData = undefined;
    this.dataSet = undefined;
    let tempDS: DataSet;
    if (reply.ImmediateManagedDataReply) {
      tempDS = <DataSet>reply.ImmediateManagedDataReply.CacheData.Payload;
    } 

    if (tempDS && tempDS.columns) {
      this.dataSet = tempDS;
    } else if (reply.ImmediateManagedDataReply) {
      this.freeJsonData = reply.ImmediateManagedDataReply.CacheData.Payload;
    } else { // if not using middle layer then we don't get the CacheData.Payload structure just the raw JSON from the API call
      this.freeJsonData = reply.rawReply;
    }
    this.waiting = false;
  }

  onDataError(error: DataRequestError) {
    this.waiting = false;
  }
  SendWebSocketMessage() {
    if (this.webSocketInputMessage && this.webSocketInputMessage.length) {
      this.webSocketObj.InputStream.next(this.webSocketInputMessage);
    }
  }
  ngOnDestroy() {
    if (this.wsMessagesSubscription) { this.wsMessagesSubscription.unsubscribe(); }
  }
}
